// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export let AlertAfterExecute = {
    STOP: 0,
    REMOVE: 1
}
export let AlertAfterExecuteMap =
{
    0: "Stop",
    1: "Remove"
}